import {
  ConfigureOptionsParams,
  FilterOptions,
  FilterPassParams,
} from '../filter-types';
import { FilterResultFacade } from '../filter-result-facade';
import { FilterHandlerBase } from './base/filter-handler-base';

export class DefaultFilterHandler extends FilterHandlerBase {
  // isInclusiveExclusive: boolean;

  // name: string;

  configureFilterOptions(params: ConfigureOptionsParams): void {
    return;
  }

  getFilterOptions(filterOptions: FilterOptions): void {
    return;
  }

  hasValidDiff(options: FilterOptions, grid: any, store: any): boolean {
    return false;
  }

  doFilterPass(params: FilterPassParams, result: FilterResultFacade): boolean {
    return true;
  }
}
